import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Tooltip from '@mui/material/Tooltip';

import logo from "../Files/IBG Logo without background.svg";
import logoWhite from "../Files/IBG-Alha Technology Logo white.svg";
import logoSingleWhite from "../Files/IBG Logo single  white.svg";
import logo2 from "../Files/IBG Logo.svg";
import { Drawer } from '@mui/material';
import { AltRoute, ArrowOutward, Autorenew, Campaign, ChevronRight, Code, Dns, Handshake, KeyboardArrowDown } from '@mui/icons-material';
import Produits from "../Data/Produits.json";
import Services from "../Data/Services.json";
import { Images } from '../Data/Images';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Langue from './Langue';
import Mode from './Mode';
import SearchPage from './SearchPage';
import iaLogo from "../Files/ia.png";

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [megaIdx, setMegaIdx] = React.useState(0);
  const [svcIdx, setSvcIdx] = React.useState(0);
  const SVC_ICONS: Record<string, React.ReactNode> = {
    '1': <Autorenew />, '2': <Code />, '3': <Dns />, '4': <Campaign />, '5': <Handshake />,
  };
  const navigate = useNavigate()
  const { t, i18n } = useTranslation();
  const pages = [t("accueil") + '|/', t("apropos") + '|/about', t("services") + '|/#services', t("produit") + "|/#products ", t("contactM") + "|/contact", t("carriere") + "|/career", t("articles") + "|/articles"];


  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleClick = (event: React.MouseEvent<HTMLDivElement>, link: string) => {
    navigate(link)
    const anchor =
      (
        (event.target as HTMLDivElement).ownerDocument || document
      ).querySelector(link.includes("#") ? ("#" + link.split("#")[1]) : "#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    }
  };

  React.useEffect(() => {
    const currentPath = window.location.pathname + window.location.hash;
    if (currentPath.includes("#")) {
      const anchor = document.querySelector(currentPath.split("#")[1] ? ("#" + currentPath.split("#")[1]) : "#back-to-top-anchor");
      if (anchor) {
        anchor.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        });
      }
    }
  }, []);


  const isDark = document.documentElement.dataset.theme === 'dark';
  const currentPath = window.location.pathname + window.location.hash;
  const isActive = (link: string) => {
    const target = link.trim();
    if (target === '/#products') return currentPath === '/#products' || currentPath.startsWith('/products');
    return target === '/' ? currentPath === '/' : currentPath.startsWith(target);
  };
  const pick = (value: string) => value.split('|')[i18n.language === 'fr' ? 0 : 1]?.trim();
  const goLink = (event: React.MouseEvent<HTMLDivElement>, link: string) => {
    if (link.startsWith('http')) {
      window.open(link, '_blank', 'noopener');
      return;
    }
    handleClick(event, link);
  };

  return (
    <AppBar position="fixed" elevation={0} className='ibg-nav'>
      <Container maxWidth="lg" className='ibg-nav__container'>
        <Toolbar disableGutters className='ibg-nav__toolbar'>
          <Box sx={{ display: { xs: 'flex', lg: 'none' } }}>
            <IconButton
              aria-label="menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              className='ibg-nav__burger'
            >
              <MenuIcon />
            </IconButton>
          </Box>

          <Link to={"/"} className='ibg-nav__logo'>
            <Box component="img" draggable={false} src={isDark ? logoWhite : logo} alt="IBG Alpha Technology" sx={{ display: { xs: 'none', sm: 'block' } }} />
            <Box component="img" draggable={false} src={isDark ? logoSingleWhite : logo2} alt="IBG Alpha Technology" className='ibg-nav__logo--mark' sx={{ display: { xs: 'block', sm: 'none' } }} />
          </Link>

          <Box component="nav" className='ibg-nav__links' sx={{ display: { xs: 'none', lg: 'flex' } }}>
            {pages.map((page) => {
              const label = page.split('|')[0];
              const link = page.split('|')[1].trim();
              if (link === '/#products') {
                return (
                  <div key={label} className='ibg-nav__mega'>
                    <button
                      className={`ibg-nav__link ${isActive(link) ? 'is-active' : ''}`}
                      onClick={(e: any) => { handleClick(e, link) }}
                    >
                      {label}
                      <KeyboardArrowDown className='ibg-nav__caret' fontSize='small' />
                    </button>
                    <div className='ibg-mega'>
                      <div className='ibg-mega__split'>
                        <div className='ibg-mega__list'>
                          {Produits.map((p, i) => (
                            <button
                              key={p.id}
                              className={`ibg-mega__item ${i === megaIdx ? 'is-active' : ''}`}
                              onMouseEnter={() => setMegaIdx(i)}
                              onFocus={() => setMegaIdx(i)}
                              onClick={(e: any) => goLink(e, p.link)}
                            >
                              <span className='ibg-mega__itemTitle'>{pick(p.title)}</span>
                              <ChevronRight className='ibg-mega__itemArrow' />
                            </button>
                          ))}
                        </div>
                        <button key={megaIdx} className='ibg-mega__preview' onClick={(e: any) => goLink(e, Produits[megaIdx].link)}>
                          <span className={`ibg-mega__media ${Produits[megaIdx].fit === 'contain' ? 'ibg-mega__media--contain' : ''}`}>
                            {Images.products[megaIdx]?.src && <img src={Images.products[megaIdx].src} alt={Images.products[megaIdx].alt} loading='lazy' draggable={false} />}
                          </span>
                          <span className='ibg-mega__body'>
                            <span className='ibg-mega__title'>
                              {pick(Produits[megaIdx].title)} <ArrowOutward className='ibg-mega__titleIcon' fontSize='small' />
                            </span>
                            <span className='ibg-mega__desc'>{pick(Produits[megaIdx].description)}</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              }
              if (link === '/#services') {
                return (
                  <div key={label} className='ibg-nav__mega'>
                    <button
                      className={`ibg-nav__link ${isActive(link) ? 'is-active' : ''}`}
                      onClick={(e: any) => { handleClick(e, link) }}
                    >
                      {label}
                      <KeyboardArrowDown className='ibg-nav__caret' fontSize='small' />
                    </button>
                    <div className='ibg-mega'>
                      <div className='ibg-mega__split'>
                        <div className='ibg-mega__list'>
                          {Services.map((s, i) => (
                            <button
                              key={s.id}
                              className={`ibg-mega__item ${i === svcIdx ? 'is-active' : ''}`}
                              onMouseEnter={() => setSvcIdx(i)}
                              onFocus={() => setSvcIdx(i)}
                              onClick={(e: any) => { handleClick(e, '/#services') }}
                            >
                              <span className='ibg-mega__itemTitle'>{pick(s.title)}</span>
                              <ChevronRight className='ibg-mega__itemArrow' />
                            </button>
                          ))}
                        </div>
                        <button key={svcIdx} className='ibg-mega__preview' onClick={(e: any) => { handleClick(e, '/#services') }}>
                          <span className='ibg-mega__media ibg-mega__media--svc'>
                            <span className='ibg-mega__svcIndex'>{String(svcIdx + 1).padStart(2, '0')}</span>
                            {SVC_ICONS[Services[svcIdx].id] || <AltRoute />}
                          </span>
                          <span className='ibg-mega__body'>
                            <span className='ibg-mega__title'>
                              {pick(Services[svcIdx].title)} <ArrowOutward className='ibg-mega__titleIcon' fontSize='small' />
                            </span>
                            <span className='ibg-mega__desc'>{pick(Services[svcIdx].provider)}</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              }
              return (
                <button
                  key={label}
                  className={`ibg-nav__link ${isActive(link) ? 'is-active' : ''}`}
                  onClick={(e: any) => { handleClick(e, link) }}
                >
                  {label}
                </button>
              );
            })}
          </Box>

          <Box className='ibg-nav__actions'>
            <SearchPage />
            <Mode />
            <Langue />
            <Tooltip title={"FOCUS IA CHAT"}>
              <IconButton className='ibg-nav__ai' onClick={(e: any) => { handleClick(e, "/focusia") }}>
                <img src={iaLogo} alt="Focus IA" />
              </IconButton>
            </Tooltip>
          </Box>

          <Drawer
            variant="temporary"
            open={Boolean(anchorElNav)}
            onClose={() => { setAnchorElNav(null) }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: 'block', lg: 'none' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 300 },
            }}
          >
            <Box className='ibg-drawer'>
              <Link to={"/"} className='ibg-drawer__logo'>
                <img draggable={false} src={isDark ? logoWhite : logo} alt="IBG Alpha Technology" />
              </Link>
              <nav>
                {pages.map((page) => {
                  const label = page.split('|')[0];
                  const link = page.split('|')[1].trim();
                  return (
                    <React.Fragment key={page}>
                      <button
                        className={`ibg-drawer__link ${isActive(link) ? 'is-active' : ''}`}
                        onClick={(e: any) => { setAnchorElNav(null); handleClick(e, link) }}
                      >
                        {label}
                      </button>
                      {link === '/#products' && (
                        <div className='ibg-drawer__sub'>
                          {Produits.map((p) => (
                            <button
                              key={p.id}
                              className='ibg-drawer__sublink'
                              onClick={(e: any) => { setAnchorElNav(null); goLink(e, p.link) }}
                            >
                              {pick(p.title)}
                            </button>
                          ))}
                        </div>
                      )}
                    </React.Fragment>
                  );
                })}
              </nav>
              {/* <center style={{ width: "100%", fontSize: "small" }} className='textgray'> <Footer /> </center> */}
            </Box>
          </Drawer>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;